/**
 * @format
 */

import React, { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import sidebar from 'img/sidebar.png';
import notification from 'img/bell.png';
import Date from 'components/datePicker';
import { toggleNotification, toggleMenu } from 'state/slice/sidebar';
import { MenuContainer } from 'features/layout';

interface LayoutProps {
  children: ReactNode;
}

/**
 * Layout component
 * Main layout wrapper for pages
 */
const Layout: React.FC<LayoutProps> = ({ children }) => {
  const dispatch = useDispatch();

  return (
    <div className='container'>
      <MenuContainer />

      <header className='header'>
        <div className='right-heading-div'>
          <img
            src={sidebar}
            alt='Toggle side menu'
            onClick={() => dispatch(toggleMenu())}
          />
          <span>Dashboard</span>
        </div>
        <div className='date-filter-container'>
          <p>Filter By</p>
          <Date />
        </div>
        <div className='left-heading-div'>
          <img src={notification} alt='bell icon' />
          <img
            src={sidebar}
            alt='Toggle side bar'
            onClick={() => dispatch(toggleNotification())}
          />
        </div>
      </header>

      <main className='main'>{children}</main>

    {/**  <UserProfile />
      <UserSetting /> */}
    </div>
  );
};

export default Layout;
